import React from "react";
import { TiDelete } from "react-icons/ti";
import { Aa } from "../functions/Aa";

const AddressItem = ({ item, isSelected, onSelect, onDelete }) => {
  return (
    <div
      onClick={() => {
        onSelect();
      }}
      className="address-item"
    >
      <div
        className="address-item__delete-btn profil-delete-btn"
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
      >
        <TiDelete size={30} color={"#ff114d"} />
      </div>
      <span>{Aa(item?.receiver_name)},</span>
      <span>{Aa(item?.phone_number)},</span>
      <span>{Aa(item?.street_name)},</span>
      <span>{Aa(item?.line_address)},</span>
      <span>{Aa(item?.instruction)}</span>
      <div
        className={`address-item__indicator ${
          isSelected ? "address-item__indicator--selected" : ""
        }`}
      ></div>
    </div>
  );
};

export default AddressItem;
